export enum BlockReleaseState {
	AUTO_RELEASE = 'AUTO_RELEASE',
	PENDING_RELEASE = 'PENDING_RELEASE',
	MANUAL_RELEASE = 'MANUAL_RELEASE',
	SSM_RELEASE = 'SSM_RELEASE',
	NOT_RELEASED = 'NOT_RELEASED',
	RECOMMENDED_RELEASE = 'RECOMMENDED_RELEASE',
	RECOMMENDED_RELEASE_REJECTED = 'RECOMMENDED_RELEASE_REJECTED',
	FLIP_RECOMMENDATION = 'FLIP_RECOMMENDATION',
}
